export const CIRCLE_SIZE = 190;
export const CIRCLE_OFFSET = 20;
export const NEUTRAL_CIRCLE_SIZE = 142;
export const BUBBLE_SIZE = CIRCLE_SIZE - CIRCLE_OFFSET;
